import {
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  SkeletonText,
} from "@chakra-ui/react";
import { format } from "date-fns";

import UnpaidIcon from "@/assets/UnpaidIcon";
import PaidIcon from "@/assets/PaidIcon";
import RejectIcon from "@/assets/RejectIcon";
import FileIcon from "@/assets/FileIcon";
import PayDisableIcon from "@/assets/PayDisableIcon";
import PayIcon from "@/assets/PayIcon";
import InProgress from "@/assets/InProgress";
import Pagination from "../Layouts/Pagination";
import { COLORS, INVOICE_STATUS, PAYMENT_STATUS } from "@/common/constants";
import { capitalizeFirstLetter } from "@/utils/letter";
import { getCurrencySymbol } from "@/utils/currency";

const TableInvoiceShipOwner = ({ dataList, isLoading, handlePay, currentPageSize, handleChangePageSize, handleChangePageNumber, currentPageNumber, totalPageNumber, hasNextPage, handleDownload }: any) => {
    const NUM_COLUMNS = 11;
    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Order Number</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Type</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>SIRE Type</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Market</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Invoice ID</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>PO Number</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Invoice Date</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Vessel Name</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Amount</Th>
                            {/* <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>PPN (%)</Th> */}
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>PPN (Amount)</Th>
                            {/*<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Invoice Status</Th>*/}
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" textAlign='center' fontSize={14}>Payment Status</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Note</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" textAlign='center' fontSize={14}>File</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" textAlign='center' fontSize={14}>Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {isLoading &&
                            <Tr>
                                <Td colSpan={NUM_COLUMNS}>
                                    <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                                </Td>
                            </Tr>
                        }
                        {(!isLoading && (!dataList || dataList.length === 0)) &&
                            <Tr>
                                <Td colSpan={NUM_COLUMNS} textAlign="center">Data not found</Td>
                            </Tr>
                        }
                        {!isLoading && dataList?.map((item: any) => {
                            return (
                                <Tr key={item.id}>
                                    <Td>{item.sequenceID || '-'}</Td>
                                    <Td textAlign='center'>{item.type || '-'}</Td>
                                    <Td>{capitalizeFirstLetter(item.sireType) || '-'}</Td>
                                    <Td>{item.market || '-'}</Td>
                                    <Td>{item.invoiceID}</Td>
                                    <Td>{item.poNumber|| '-'}</Td>
                                    <Td>{item.invoiceDate ? format(item.invoiceDate, 'dd-MM-yyyy') : '-'}</Td>
                                    <Td>{item.shipName}</Td>
                                    <Td textAlign='right'>{item.currency ? getCurrencySymbol(item.currency, item.amount) : '-'}</Td>
                                    {/* <Td textAlign='right'>{item.isPPN ? item.ppn : '-'}</Td> */}
                                    <Td textAlign='right'>{item.currency ? getCurrencySymbol(item.currency, item.ppnPrice) : '-'}</Td>
                                    {/*<Td>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {item.invoiceStatus === INVOICE_STATUS.APPROVED && <ApprovedIcon />}
                                            {item.invoiceStatus === INVOICE_STATUS.IN_PROGRESS && <NewIcon />}
                                            {item.invoiceStatus === INVOICE_STATUS.REJECTED && <RejectIcon />}
                                        </div>
                                    </Td>*/}
                                    <Td textAlign='center'>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {item.paymentStatus === PAYMENT_STATUS.UNPAID && <UnpaidIcon />}
                                            {item.paymentStatus === PAYMENT_STATUS.PAID && <InProgress />}
                                            {item.paymentStatus === PAYMENT_STATUS.COMPLETED && <PaidIcon />}
                                            {item.paymentStatus === PAYMENT_STATUS.REJECTED && <RejectIcon />}
                                        </div>
                                    </Td>
                                    <Td>{item.note ?? '-'}</Td>
                                    <Td textAlign='center'>
                                        {item.downloadId && <FileIcon style={{ cursor: 'pointer', display: 'inline' }} onClick={() => handleDownload(item.downloadId)} />}
                                        {!item.downloadId && <p>-</p>}
                                    </Td>
                                    <Td textAlign='center'>
                                        {/*(item.invoiceStatus === INVOICE_STATUS.IN_PROGRESS)
                                        ? <ButtonConfirm onClick={() => handleConfirm(item.id)} style={{ cursor: 'pointer', display: 'inline', marginRight: 3 }} />
                                        : <ButtonConfirmDisabled style={{ display: 'inline', marginRight: 3 }} />*/}
                                        {((item.paymentStatus === PAYMENT_STATUS.UNPAID || item.paymentStatus === PAYMENT_STATUS.REJECTED) && item.invoiceStatus === INVOICE_STATUS.APPROVED)
                                        ? <PayIcon onClick={() => handlePay(item.id)} style={{ cursor: 'pointer', display: 'inline' }} />
                                        : <PayDisableIcon style={{ display: 'inline' }} />}
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </Box>
            <Pagination currentPageSize={currentPageSize} currentPageNumber={currentPageNumber} totalPageNumber={totalPageNumber} handleChangePageSize={handleChangePageSize} handleChangePageNumber={handleChangePageNumber} hasNextPage={hasNextPage} />
        </TableContainer>
    )
}

export default TableInvoiceShipOwner;
